import {
  _initialState,
  _expandDirectMerchantRow,
  _expandPartnersRow,
  _updateLoadCommissionShow,
  _setCommissionShow,
  _setCommissionDirectMerchants,
  _setCommissionPartners,
  _commissionShowFailed,
  _commissionUpdateShowFailed,
  _changePage,
  _setPerPageFilter,
  _setPaginatorTotal,
  _orderByDirectMerchantsCreatedAt,
  _orderByDirectMerchantsMerchantName,
  _orderByDirectMerchantsProcessingVolume,
  _orderByDirectMerchantsTransactionFee,
  _orderByDirectMerchantsCommission,
  _orderByPartnersCompanyName,
  _orderByPartnersNumMerchants,
  _orderByPartnersProcessingVolume,
  _orderByPartnersTransactionFee,
  _orderByPartnersCommission
} from '../components/show/reducerUtil';

export const SET_COMMISSION_DIRECT_MERCHANTS =
  'CommissionDueShow/SET_COMMISSION_DIRECT_MERCHANTS';
export const SET_COMMISSION_PARTNERS =
  'CommissionDueShow/SET_COMMISSION_PARTNERS';
export const EXPAND_DIRECT_MERCHANT_ROW =
  'CommissionDueShow/EXPAND_DIRECT_MERCHANT_ROW';
export const EXPAND_PARTNERS_ROW = 'CommissionDueShow/EXPAND_PARTNERS_ROW';
export const LOAD_COMMISSION_SHOW = 'CommissionDueShow/LOAD_COMMISSION_SHOW';
export const UPDATE_LOAD_COMMISSION_SHOW =
  'CommissionDueShow/UPDATE_LOAD_COMMISSION_SHOW';
export const SET_COMMISSION_SHOW_DATA =
  'CommissionDueShow/SET_COMMISSION_SHOW_DATA';
export const CHANGE_PAGE = 'CommissionDueShow/CHANGE_PAGE';
export const COMMISSION_SHOW_FAILED =
  'CommissionDueShow/COMMISSION_SHOW_FAILED';
export const COMMISSION_UPDATE_SHOW_FAILED =
  'CommissionDueShow/COMMISSION_UPDATE_SHOW_FAILED';
export const SET_PER_PAGE_FILTER = 'CommissionDueShow/SET_PER_PAGE_FILTER';
export const SET_PAGINATOR_TOTAL = 'CommissionDueShow/SET_PAGINATOR_TOTAL';

export const ORDER_BY_DIRECT_MERCHANTS_CREATED_AT =
  'CommissionDueShow/ORDER_BY_DIRECT_MERCHANTS_CREATED_AT';
export const ORDER_BY_DIRECT_MERCHANTS_MERCHANT_NAME =
  'CommissionDueShow/ORDER_BY_DIRECT_MERCHANTS_MERCHANT_NAME';
export const ORDER_BY_DIRECT_MERCHANTS_PROCESSING_VOLUME =
  'CommissionDueShow/ORDER_BY_DIRECT_MERCHANTS_PROCESSING_VOLUME';
export const ORDER_BY_DIRECT_MERCHANTS_TRANSACTION_FEE =
  'CommissionDueShow/ORDER_BY_DIRECT_MERCHANTS_TRANSACTION_FEE';
export const ORDER_BY_DIRECT_MERCHANTS_COMMISSION =
  'CommissionDueShow/ORDER_BY_DIRECT_MERCHANTS_COMMISSION';

export const ORDER_BY_PARTNERS_COMPANY_NAME =
  'CommissionDueShow/ORDER_BY_PARTNERS_COMPANY_NAME';
export const ORDER_BY_PARTNERS_NUM_MERCHANTS =
  'CommissionDueShow/ORDER_BY_PARTNERS_NUM_MERCHANTS';
export const ORDER_BY_PARTNERS_PROCESSING_VOLUME =
  'CommissionDueShow/ORDER_BY_PARTNERS_PROCESSING_VOLUME';
export const ORDER_BY_PARTNERS_TRANSACTION_FEE =
  'CommissionDueShow/ORDER_BY_PARTNERS_TRANSACTION_FEE';
export const ORDER_BY_PARTNERS_COMMISSION =
  'CommissionDueShow/ORDER_BY_PARTNERS_COMMISSION';

export const expandDirectMerchantRow = id => ({
  type: EXPAND_DIRECT_MERCHANT_ROW,
  id
});

export const expandPartnersRow = id => ({
  type: EXPAND_PARTNERS_ROW,
  id
});

export const commissionShowFailed = () => ({
  type: COMMISSION_SHOW_FAILED
});

export const commissionUpdateShowFailed = () => ({
  type: COMMISSION_UPDATE_SHOW_FAILED
});

export const loadCommissionShow = params => ({
  type: LOAD_COMMISSION_SHOW,
  params
});
export const updateLoadCommissionShow = params => ({
  type: UPDATE_LOAD_COMMISSION_SHOW,
  params
});

export const setCommissionShow = (summary, directMerchant, selectedIso) => ({
  type: SET_COMMISSION_SHOW_DATA,
  summary,
  directMerchant,
  selectedIso
});

export const setCommissionDirectMerchants = directMerchant => ({
  type: SET_COMMISSION_DIRECT_MERCHANTS,
  directMerchant
});

export const setCommissionPartners = partners => ({
  type: SET_COMMISSION_PARTNERS,
  partners
});

export const setPerPageFilter = perPageFilter => ({
  type: SET_PER_PAGE_FILTER,
  perPageFilter
});

export const changePage = params => ({
  type: CHANGE_PAGE,
  params
});

export const setPaginatorTotal = paginatorTotal => ({
  type: SET_PAGINATOR_TOTAL,
  paginatorTotal
});

export const orderByDirectMerchantsCreatedAt = orderByState => ({
  type: ORDER_BY_DIRECT_MERCHANTS_CREATED_AT,
  orderByState
});

export const orderByDirectMerchantsMerchantName = orderByState => ({
  type: ORDER_BY_DIRECT_MERCHANTS_MERCHANT_NAME,
  orderByState
});

export const orderByDirectMerchantsProcessingVolume = orderByState => ({
  type: ORDER_BY_DIRECT_MERCHANTS_PROCESSING_VOLUME,
  orderByState
});

export const orderByDirectMerchantsTransactionFee = orderByState => ({
  type: ORDER_BY_DIRECT_MERCHANTS_TRANSACTION_FEE,
  orderByState
});

export const orderByDirectMerchantsCommission = orderByState => ({
  type: ORDER_BY_DIRECT_MERCHANTS_COMMISSION,
  orderByState
});

export const orderByPartnersCompanyName = orderByState => ({
  type: ORDER_BY_PARTNERS_COMPANY_NAME,
  orderByState
});

export const orderByPartnersNumMerchants = orderByState => ({
  type: ORDER_BY_PARTNERS_NUM_MERCHANTS,
  orderByState
});

export const orderByPartnersProcessingVolume = orderByState => ({
  type: ORDER_BY_PARTNERS_PROCESSING_VOLUME,
  orderByState
});

export const orderByPartnersTransactionFee = orderByState => ({
  type: ORDER_BY_PARTNERS_TRANSACTION_FEE,
  orderByState
});

export const orderByPartnersCommission = orderByState => ({
  type: ORDER_BY_PARTNERS_COMMISSION,
  orderByState
});

export default (state = _initialState, action) => {
  switch (action.type) {
    case EXPAND_DIRECT_MERCHANT_ROW:
      return _expandDirectMerchantRow(state, action);
    case EXPAND_PARTNERS_ROW:
      return _expandPartnersRow(state, action);
    case LOAD_COMMISSION_SHOW:
      return _initialState;
    case UPDATE_LOAD_COMMISSION_SHOW:
      return _updateLoadCommissionShow(state);
    case SET_COMMISSION_SHOW_DATA:
      return _setCommissionShow(state, action);
    case SET_COMMISSION_DIRECT_MERCHANTS:
      return _setCommissionDirectMerchants(state, action);
    case SET_COMMISSION_PARTNERS:
      return _setCommissionPartners(state, action);
    case COMMISSION_SHOW_FAILED:
      return _commissionShowFailed(state);
    case COMMISSION_UPDATE_SHOW_FAILED:
      return _commissionUpdateShowFailed(state);
    case CHANGE_PAGE:
      return _changePage(state, action);
    case SET_PER_PAGE_FILTER:
      return _setPerPageFilter(state, action);
    case SET_PAGINATOR_TOTAL:
      return _setPaginatorTotal(state, action);
    case ORDER_BY_DIRECT_MERCHANTS_CREATED_AT:
      return _orderByDirectMerchantsCreatedAt(state, action);
    case ORDER_BY_DIRECT_MERCHANTS_MERCHANT_NAME:
      return _orderByDirectMerchantsMerchantName(state, action);
    case ORDER_BY_DIRECT_MERCHANTS_PROCESSING_VOLUME:
      return _orderByDirectMerchantsProcessingVolume(state, action);
    case ORDER_BY_DIRECT_MERCHANTS_TRANSACTION_FEE:
      return _orderByDirectMerchantsTransactionFee(state, action);
    case ORDER_BY_DIRECT_MERCHANTS_COMMISSION:
      return _orderByDirectMerchantsCommission(state, action);
    case ORDER_BY_PARTNERS_COMPANY_NAME:
      return _orderByPartnersCompanyName(state, action);
    case ORDER_BY_PARTNERS_NUM_MERCHANTS:
      return _orderByPartnersNumMerchants(state, action);
    case ORDER_BY_PARTNERS_PROCESSING_VOLUME:
      return _orderByPartnersProcessingVolume(state, action);
    case ORDER_BY_PARTNERS_TRANSACTION_FEE:
      return _orderByPartnersTransactionFee(state, action);
    case ORDER_BY_PARTNERS_COMMISSION:
      return _orderByPartnersCommission(state, action);

    default:
      return state;
  }
};
